import React from 'react';
import SettingsCardHeader from '../molecules/SettingsCardHeader';

/**
 * White bordered card shell for settings step content.
 */
export default function SettingsCard({
  title,
  description,
  onNext,
  nextLabel,
  showNext = true,
  nextDisabled,
  nextVariant,
  children,
  footer,
  className = '',
}) {
  return (
    <section className={`ca-settings-card ${className}`.trim()}>
      <SettingsCardHeader
        title={title}
        description={description}
        onNext={onNext}
        nextLabel={nextLabel}
        showNext={showNext}
        nextDisabled={nextDisabled}
        nextVariant={nextVariant}
      />
      <div className="ca-settings-card__divider" />
      <div className="ca-settings-card__body">{children}</div>
      {footer ? <div className="ca-settings-card__footer">{footer}</div> : null}
    </section>
  );
}
